/**
 * Tab keys for the merged Retail (Evotor) settings page (`RetailSettingsPage`), in the merchant's
 * actual journey order: connect an account → load data from Evotor → map it to OBZR (bind stores,
 * turn on stock export) → export updated data to Evotor → turn on regular sync → check status.
 * Kept in its own `model/` module (rather than inline in the page) so both the page and the
 * Overview tab's launch-checklist links can import the same type without a circular dependency
 * between the page and `ui/components`.
 */
export type RetailTab = 'overview' | 'accounts' | 'stores' | 'devices' | 'sync' | 'automation';

export const RETAIL_TABS: RetailTab[] = [
  'overview',
  'accounts',
  'stores',
  'devices',
  'sync',
  'automation',
];

export function isRetailTab(value: string | null): value is RetailTab {
  return value !== null && (RETAIL_TABS as string[]).includes(value);
}
